import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { createFragmentContainer, graphql } from 'react-relay';
import classnames from 'classnames';
import get from 'lodash.get';
import CloseIcon from 'dibs-vg/dist/react/close';
import { Button } from 'dibs-elements/exports/Button';

import {
    DESIGN_SERVICE_BANNER,
    canShowDesignServiceBanner,
    increaseShowCount,
    forceCloseBanner,
} from '../../helpers/promotionBannerHelper';
import { setMatchmakerReferrer } from '../../helpers/matchmakerReferrer';

import style from './DesignServiceBanner.scss';
import { MatchmakerIcon } from 'dibs-matchmaker-icon';

export class DesignServiceBanner extends Component {
    static getDerivedStateFromProps(props, state) {
        if (!state.isOnClient) {
            return null;
        }

        const isVip = get(props.user, 'isVip');
        const isVerifiedTrade = get(props.user, 'isVerifiedTrade');
        const isOpen = canShowDesignServiceBanner({ isVip, isVerifiedTrade });
        return { isOpen };
    }

    constructor() {
        super();

        this.state = {
            isOnClient: false,
            isOpen: false,
        };

        this.onClose = this.onClose.bind(this);
    }
    componentDidMount() {
        const isVip = get(this.props.user, 'isVip');
        const isVerifiedTrade = get(this.props.user, 'isVerifiedTrade');
        const isOpen = canShowDesignServiceBanner({ isVip, isVerifiedTrade });
        if (isOpen) {
            increaseShowCount(DESIGN_SERVICE_BANNER);
        }
        this.setState({ isOnClient: true, isOpen }); // eslint-disable-line react/no-did-mount-set-state
    }
    onClose(event) {
        event.preventDefault();
        this.setState({ isOpen: false });
        forceCloseBanner(DESIGN_SERVICE_BANNER);
    }
    render() {
        const { isOpen } = this.state;
        const className = classnames('primary-viewport-width', style.viewport, {
            [style.isOpen]: isOpen,
        });

        return (
            <div className={className}>
                <div className={`main-content-resp ${style.container}`}>
                    <a href="#0" onClick={this.onClose} data-tn="design-service-banner-close">
                        <CloseIcon className={style.close} />
                    </a>
                    <div className={style.header}>
                        <FormattedMessage
                            id="designServiceBanner.header"
                            defaultMessage="Looking for an interior designer?"
                        />
                    </div>

                    <div className={style.content}>
                        <FormattedMessage
                            id="designServiceBanner.content"
                            defaultMessage="With our free service, Designer Connection, we'll recommend designers based on your style and needs."
                        />
                    </div>

                    <Button
                        size="medium"
                        className={style.cta}
                        href="/trade/designer-connection/"
                        onClick={() => setMatchmakerReferrer('banner - favorites')}
                    >
                        <FormattedMessage
                            id="designServiceBanner.cta"
                            defaultMessage="Try Designer Connection"
                        />
                    </Button>

                    <MatchmakerIcon iconWrapperClass={style.iconWrapper} />

                    <div className={style.footer}>
                        <span className={style.smallText}>
                            <FormattedMessage id="designServiceBanner.or" defaultMessage="OR" />
                        </span>

                        <FormattedMessage
                            id="designServiceBanner.browseDesignersLink"
                            defaultMessage="Browse our {directoryLink} of interior designers."
                            values={{
                                directoryLink: (
                                    <a href="/design-firms/directory/">
                                        <FormattedMessage
                                            id="designServiceBanner.directory"
                                            defaultMessage="directory"
                                        />
                                    </a>
                                ),
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

DesignServiceBanner.propTypes = {
    user: PropTypes.shape({
        isVerifiedTrade: PropTypes.bool,
    }),
};

export default createFragmentContainer(DesignServiceBanner, {
    user: graphql`
        fragment DesignServiceBanner_user on User {
            isVip
            isVerifiedTrade
        }
    `,
});
